module.exports = __webpack_public_path__ + "Roboto-300.634f53eb79efa455a9e9.ttf";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src590146077/src/src/assets/fonts/roboto/fonts/Roboto-300/Roboto-300.ttf
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-300/Roboto-300.ttf
// module chunks = main styles